module.exports = __webpack_public_path__ + "img/aej1n-66wvl.003.f8700afa.png";